import styled from 'styled-components';

import { COLORS, LOGIN, MOBILE } from '../../../theme/tokens';

/**
 * Full-bleed auth screen for the Telegram callback, styled to match `/login`: the
 * brand lockup, a centred kept-dark card, and the language switcher stacked down the
 * page. This route owns its own Screen (no layout / auth gate wraps it).
 */
export const Screen = styled.div`
  min-height: 100dvh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 48px;
  padding: 48px 24px;
  background: ${LOGIN.pageBg};

  ${MOBILE} {
    gap: 32px;
    padding: 24px 16px;
  }
`;

/** Sizes the AuthLogo lockup (it is intentionally unsized on its own and relies on a
 *  `.logo { width: 200px }` host rule, which the login page provides and this screen
 *  must too, or the 779px SVG paints at natural width). */
export const LogoSlot = styled.div`
  width: 200px;
  display: flex;

  /* AuthLogo's root carries the \`.logo\` class; pin it to the slot width so the img
     percentage resolves against a concrete box (else the 779px SVG uses its natural
     width). */
  .logo {
    width: 100%;
  }

  img {
    width: 100%;
    height: auto;
  }
`;

export const Card = styled.div`
  width: 100%;
  max-width: 480px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 24px;
  border-radius: 24px;
  background: ${LOGIN.bodyBg};
  box-shadow: ${LOGIN.cardShadow};
  text-align: center;
`;

export const Title = styled.h1`
  margin: 0;
  font-size: 28px;
  font-weight: 800;
  line-height: 1.12;
  background: ${LOGIN.titleGradient};
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  /* Extend the clip paint area under the descenders and give the space back, so a
     'g'/'y' tail is not flat-cut (same fix as the login title). */
  padding-bottom: 4px;
  margin-bottom: -4px;
`;

export const Message = styled.p`
  margin: 0;
  font-size: 14px;
  line-height: 1.43;
  color: ${LOGIN.subtitle};
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 12px;
  text-align: left;
`;

export const Input = styled.input`
  width: 100%;
  box-sizing: border-box;
  height: 48px;
  padding: 0 14px;
  border: 1px solid ${COLORS.featureCardBorder};
  border-radius: 12px;
  background: ${COLORS.surfaceMuted};
  color: ${COLORS.text};
  font-size: 16px;

  &::placeholder {
    color: ${COLORS.textFaint};
  }
`;

export const ErrorText = styled.p`
  margin: 0;
  font-size: 13px;
  color: ${COLORS.ctaSolid};
`;
